import { Injectable } from '@angular/core';
import { DataService } from '@barthauer/abc/core/data';
import { ParameterValue } from '@barthauer/abc/queries/parameters/core';
import { EditorInstanceSettings } from 'libs/abc/ui-components/src/lib/core/src/abc-grid/abc-grid';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EditorService {
  public editorIndex: number = 0;
  public editorInstances: EditorInstanceSettings[] = [];

  constructor(private coreDataService: DataService) {}

  public setValue(queryValue: ParameterValue): void {
    this.coreDataService.executeSetValueQuery(queryValue).subscribe();
  }

  public getValue(queryValue: ParameterValue): Observable<any> {
    return this.coreDataService.executeGetValueQuery(queryValue);
  }
}
